import i18n from "@/i18n/config";
import type { AttachmentFileState } from "./hooks/useAppBindings";

export const ATTACHMENT_FILE_STATES: AttachmentFileState[] = [
  "normal_standard",
  "normal_external",
  "external_unmigrated",
  "standard_unmigrated",
  "migration_preparing",
  "migration_record_update_pending",
  "source_carrier_cleanup_pending",
  "migration_blocked",
  "migration_failed",
  "placement_reconciliation_required",
  "reference_broken",
  "reference_unconfirmed",
];

export function attachmentFileStateLabel(state: AttachmentFileState) {
  return i18n.t(`app-bindings:attachmentFileStates.${state}`);
}

export function formatDateTime(value?: string | null) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString("ja-JP");
}

export function normalizePageLimit(value: string | null, fallback: "5" | "20" | "50" | "100") {
  if (value === "5" || value === "20" || value === "50" || value === "100") {
    return value;
  }
  return fallback;
}
